/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createActionsHook,
	createStateHook,
	createStore,
	type HookStateFunction,
} from '@atlassian/react-sweet-state';

type CustomThemeData = {
	cloudId?: string;
	customLogoSize?: {
		width?: number;
		height?: number;
	};
	customSiteTitleLength?: number;
	hasCustomBGColor?: boolean;
	hasCustomHighlightColor?: boolean;
	hasCustomLogo?: boolean;
	hasCustomSiteTitle?: boolean;
};

const initialState: CustomThemeData = {};

const store = createStore({
	name: 'navigation-custom-theme-context',
	initialState,
	actions: {
		update:
			(customThemeData: Partial<CustomThemeData>) =>
			({ setState }) => {
				setState(customThemeData);
			},
	},
});

export const useCustomThemeData: HookStateFunction<CustomThemeData, void> = createStateHook(store);

const useCustomThemeContextActions = createActionsHook(store);
export const useSetCustomThemeData = (): ((customThemeData: Partial<CustomThemeData>) => void) =>
	useCustomThemeContextActions().update;
